import { BemWithSpecificContext } from "@cynaps/core";

export const { Block, Elem } = BemWithSpecificContext();
